import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import { CylinderProgress3Divide } from "../../../Components/KPI/CylinderProgressBarCustomPvin3Divide";

const TataCareCouponApi = async (selectedFilter) => {
  const res = await axInst.post("pvin/tata-coupon", selectedFilter);
  return res.data;
};

const LoyaltyPointsApi = async (selectedFilter) => {
  const res = await axInst.post("pvin/tata-loyality", selectedFilter);
  return res.data;
};

const TataCareCoupon = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const {
    data: TataCareCouponData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["TataCareCouponData", selectedFilter],
    queryFn: () => TataCareCouponApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  const {
    data: TataLoyalityData,
    isFetching2,
    isError2,
  } = useQuery({
    queryKey: ["TataLoyalityData", selectedFilter],
    queryFn: () => LoyaltyPointsApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <div className="text-center text-red-500 p-4">Failed to load data</div>
    );

  return (
    <div className="md:flex block w-full gap-3">
      <div className="md:w-1/2 w-full bg-white rounded-lg shadow-sm p-2 relative">
        <WaterMark />
        <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-3">
          Loyality Points
        </h2>

        {Array.isArray(TataLoyalityData) && TataLoyalityData.length > 0 ? (
          <CylinderProgress3Divide data={TataLoyalityData} />
        ) : (
          <div className="text-center text-gray-600">No data available</div>
        )}
      </div>
      <div className="md:w-1/2 w-full bg-white rounded-lg shadow-sm p-2 relative">
        <WaterMark />
        <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-3">
          Tata Care Coupon
        </h2>

        {Array.isArray(TataCareCouponData) && TataCareCouponData.length > 0 ? (
          <CylinderProgress3Divide data={TataCareCouponData} />
        ) : (
          <div className="text-center text-gray-600">No data available</div>
        )}
      </div>
    </div>
  );
};

export default TataCareCoupon;
